/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface CreateDeviceDto
 */
export interface CreateDeviceDto {
  /**
   * Model of the device.
   *
   * @type {number}
   * @memberof CreateDeviceDto
   * @example 5
   */
  model: CreateDeviceDtoModelEnum;

  /**
   * Optional serial number of the device.
   *
   * @type {string}
   * @memberof CreateDeviceDto
   * @example SN123456789
   */
  serial?: string;

  /**
   * Number of the device, indicating the device`s configuration.
   *
   * @type {string}
   * @memberof CreateDeviceDto
   * @example EXP100
   */
  device_number?: string;

  /**
   * Optional version of the device structure, indicating the device`s hardware or software configuration.
   *
   * @type {string}
   * @memberof CreateDeviceDto
   * @example v1.0.0
   */
  structure_version?: string;

  /**
   * Optional password for device access or configuration, if applicable.
   *
   * @type {string}
   * @memberof CreateDeviceDto
   * @example P@ssw0rd!
   */
  password?: string;

  /**
   * Optional identifier of the organization that owns the device.
   *
   * @type {string}
   * @memberof CreateDeviceDto
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  o_id?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateDeviceDtoModelEnum {
  NUMBER_5 = 5,
  NUMBER_6 = 6,
  NUMBER_7 = 7,
  NUMBER_1 = 1,
}
